import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { useAuth } from "../lib/AuthContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AuthCallback = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { refresh } = useAuth();
    const hasProcessed = useRef(false);

    useEffect(() => {
        if (hasProcessed.current) return;
        hasProcessed.current = true;

        const hash = location.hash || "";
        const match = hash.match(/session_id=([^&]+)/);
        if (!match) {
            navigate("/", { replace: true });
            return;
        }
        const sessionId = decodeURIComponent(match[1]);
        (async () => {
            try {
                await axios.post(`${API}/auth/session`, { session_id: sessionId }, { withCredentials: true });
                await refresh();
            } catch {
                /* ignore */
            } finally {
                // Clear hash and go home
                window.history.replaceState(null, "", "/");
                navigate("/", { replace: true });
            }
        })();
    }, [location, navigate, refresh]);

    return (
        <div className="min-h-screen bg-background flex items-center justify-center text-muted-foreground font-mono text-sm">
            Signing you in…
        </div>
    );
};

export default AuthCallback;
